import * as React from 'react';

import type { ManageInstructorsSelectionContextValue } from './ManageInstructorsSelectionContext.types';

import { ManageInstructorsSelectionContext } from './ManageInstructorsSelectionProvider';

function useManageInstructorsSelection(): ManageInstructorsSelectionContextValue {
  const context = React.useContext(ManageInstructorsSelectionContext);

  if (!context) {
    throw new Error(
      'useManageInstructorsSelection must be used within ManageInstructorsSelectionProvider'
    );
  }

  return context;
}

export { useManageInstructorsSelection };
